import React from "react"
import PropTypes from "prop-types"
import { ButtonDropdown, Radio } from "@bitcine/cs-theme"
import 'styled-components/macro'
import ReactTooltip from "react-tooltip"

const options = [
  {
    label: "Created Date",
    key: "created_at",
    defaultSort: "DESC"
  },
  {
    label: "Name",
    key: "name",
    defaultSort: "ASC"
  }
]

const Sort = ({ sorting, updateSorting }) => {
  return (
    <ButtonDropdown
      button={{
        className: `ml1 small white`,
        text: (
          <div className='flex items-center'>
            <span style={{ fontSize: "16px" }} className='material-icons mr1'>
              sort
            </span>
            Sort
          </div>
        )
      }}
      dropdown={{
        arrow: true,
        content: (
          <div className='p2' css={`width: 240px;`}>
            <h4>Sort by</h4>
            <div>
              {options.map(option => (
                <div key={option.key} className='mt2 flex items-center justify-between'>
                  <Radio
                    label={option.label}
                    checked={sorting.sortBy === option.key}
                    onChange={() => updateSorting({
                      ...sorting,
                      sortBy: option.key,
                      sortDirection: option.defaultSort
                    })}/>
                  {option.key === sorting.sortBy && 
                    <div
                      onClick={() => updateSorting({
                        ...sorting,
                        sortBy: option.key,
                        sortDirection: sorting.sortDirection === "ASC" ? "DESC" : "ASC"
                      })}
                      css={`
                        cursor: pointer;
                        user-select: none;
                        background: lightgray;
                        border-radius: 8px;
                        font-weight: 600;
                        padding: 2px 8px;
                      `}
                      data-tip
                      data-for={option.key} 
                      className='ml2 tooltip flex items-center'>
                      <span>{sorting.sortDirection}</span>
                      <span style={{ fontSize: "16px" }} className='material-icons ml1'>
                        {sorting.sortDirection === "ASC" ? "arrow_upward" : "arrow_downward"}
                      </span> 
                    </div>}
                    <ReactTooltip id={option.key}>
                      Toggle direction
                    </ReactTooltip>
                </div>
              ))}
            </div>
          </div>
        )
      }}/>
  )
}

Sort.propTypes = {
  updateSorting: PropTypes.func.isRequired,
  sorting: PropTypes.object.isRequired,
}

export default Sort
